import { TestBuy } from "@coworker/types/lib/testbuy";
import { useStoreId, useUID } from "../../../../core/auth/useLoggedInUser";
import { useQuery } from "@tanstack/react-query";
import {
  fetchTestbuy,
  fetchTestbuys,
  fetchTestbuyTasks,
  ArticleTaskPairs,
} from "./testbuy.api";
import { TaskData } from "@coworker/apprestructured/src/testbuy/types/testbuyTaskData";
import { FixaWindow } from "@coworker/reusable/helpers/devices";

interface UseTesbuys {
  loading: boolean;
  testbuys: TestBuy[] | undefined;
}

export const useTestbuy = (id: string | undefined) => {
  return useQuery<TestBuy>({
    queryKey: ["get-testbuy-by-id", id],
    queryFn: async () => {
      return (await fetchTestbuy(id)) as TestBuy;
    },
    staleTime: 0,
  });
};

export const useTestbuys = (
  area: string | undefined,
  sinceIsoDateString: string,
  untilIsoDateString: string
) => {
  const storeId = useStoreId();
  const uid = useUID();

  const { data: testbuy, isLoading: loading } = useQuery({
    queryKey: [
      "get-testbuys",
      uid,
      area,
      storeId,
      sinceIsoDateString,
      untilIsoDateString,
    ],
    queryFn: async () => {
      if (!sinceIsoDateString || !untilIsoDateString) return [];

      return (await fetchTestbuys(
        uid,
        area,
        storeId,
        sinceIsoDateString,
        untilIsoDateString,
        ""
      )) as TestBuy[];
    },
    enabled: !!sinceIsoDateString && !!untilIsoDateString && !!uid && !!storeId,
    staleTime: 0,
  });

  return {
    loading,
    testbuys: testbuy,
  } as UseTesbuys;
};

export const useTestbuyTasks = (testbuyTasks: ArticleTaskPairs[]) => {
  return useQuery({
    queryKey: ["get-testbuy-tasks", testbuyTasks],
    queryFn: async () => {
      return (await fetchTestbuyTasks(testbuyTasks)) as TaskData[];
    },
  });
};
